// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/locazioni/:id',
    requestBody: null,
    response: '{"success":true,"data":{...locazione}}'
  },
  {
    method: 'GET',
    endpoint: '/api/sedi?societaId=',
    requestBody: null,
    response: '{"sedi":[{...sede}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi?ruolo=FORNITORE&societaId=',
    requestBody: null,
    response: '{"data":[{...nominativo}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi?ruolo=FORNITORE&societaId=',
    requestBody: null,
    response: '{"data":[{...nominativo}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/locazioni',
    requestBody: '{...form}',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/locazioni/:id',
    requestBody: '{...form}',
    response: '{"success":true}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/locazioni/:id',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/locazioni/:id/documenti',
    requestBody: 'FormData{file,tipo,descrizione?}',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/locazioni/:id/documenti/:docId',
    requestBody: null,
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
